/**
 * Autoplay Context
 * Provides section-based autoplay state to all components
 */

import React, { createContext, useContext } from 'react';
import { useAutoplayManager } from '../hooks/useAutoplayManager';

const AutoplayContext = createContext({
  activeSection: null,
  autoplaySection: null,
  shouldAutoplay: () => false,
});

export const AutoplayProvider = ({ children, heroDelay = 5000, sectionDelay = 2000 }) => {
  const autoplayState = useAutoplayManager({ heroDelay, sectionDelay });

  return (
    <AutoplayContext.Provider value={autoplayState}>
      {children}
    </AutoplayContext.Provider>
  );
};

export const useAutoplay = () => {
  const context = useContext(AutoplayContext);
  if (!context) {
    throw new Error('useAutoplay must be used within an AutoplayProvider');
  }
  return context;
};

export default AutoplayContext;
